export const siRatingEndpoints = {
  sectors: "/si-rating/sectors",
  run: "/si-rating/run",
  fromReport: (reportId) => `/si-rating/from-report/${reportId}`,
  mine: "/si-rating/mine",
  get: (id) => `/si-rating/${id}`,
  pdfReports: (id) => `/si-rating/${id}/pdf-reports`,
  values: (id) => `/si-rating/${id}/values`,
  refreshSdm: (id) => `/si-rating/${id}/refresh-sdm`,
  finalize: (id) => `/si-rating/${id}/finalize`,
  exportXlsx: (id) => `/si-rating/${id}/export.xlsx`,
  reportPdf: (id) => `/si-rating/${id}/report.pdf`,
};
